package me.tbsten.compose.preview.lab.ui.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import me.tbsten.compose.preview.lab.UiComposePreviewLabApi
import me.tbsten.compose.preview.lab.ui.PreviewLabTheme

@Composable
@UiComposePreviewLabApi
fun PreviewLabHorizontalDivider(
    modifier: Modifier = Modifier,
    thickness: Dp = PreviewLabDividerDefaults.Thickness,
    color: Color = PreviewLabDividerDefaults.color,
) = Canvas(
    modifier
        .fillMaxWidth()
        .height(thickness),
) {
    drawLine(
        color = color,
        strokeWidth = thickness.toPx(),
        start = Offset(0f, thickness.toPx() / 2),
        end = Offset(size.width, thickness.toPx() / 2),
    )
}

@Composable
@UiComposePreviewLabApi
fun PreviewLabVerticalDivider(
    modifier: Modifier = Modifier,
    thickness: Dp = PreviewLabDividerDefaults.Thickness,
    color: Color = PreviewLabDividerDefaults.color,
) = Canvas(
    modifier
        .fillMaxHeight()
        .width(thickness),
) {
    drawLine(
        color = color,
        strokeWidth = thickness.toPx(),
        start = Offset(thickness.toPx() / 2, 0f),
        end = Offset(thickness.toPx() / 2, size.height),
    )
}

@UiComposePreviewLabApi
object PreviewLabDividerDefaults {
    val Thickness: Dp = 1.dp
    val color: Color @Composable get() = PreviewLabTheme.colors.outline
}
